<template>
  <div v-if="tasks.length" class="task-cards">
    <button
      v-for="task in tasks"
      :key="task.id"
      type="button"
      class="task-card"
      :class="'task-card--' + task.status"
      @click="$emit('open', task.id)"
    >
      <span class="task-card__state">
        <i class="bi" :class="task.status === 'answered' ? 'bi-check-circle-fill' : 'bi-clock-history'" aria-hidden="true"></i>
        {{ task.status === 'answered' ? 'Respondida · conferir resposta' : 'Pendente · aguarda sua ação' }}
      </span>
      <span class="task-card__type">{{ typeLabel(task.type) }}</span>
      <strong>{{ task.title }}</strong>
      <span v-if="task.patient" class="task-card__patient"><i class="bi bi-person" aria-hidden="true"></i> {{ task.patient.name }}</span>
      <span class="task-card__meta">{{ task.status === 'answered' ? task.assignee?.name : task.author?.name }}<template v-if="task.due_at"> · {{ when(task.due_at) }}</template></span>
    </button>
  </div>
</template>

<script>
import http from '@/helpers/http';
import { taskTypeLabel } from './taskOptions';

export default {
  name: 'TaskCards',
  emits: ['open', 'count'],
  data() {
    return {
      tasks: [],
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  watch: {
    'place.id_place'() {
      this.load();
    },
  },
  created() {
    this.load();
  },
  methods: {
    typeLabel: taskTypeLabel,
    when(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return '';
      }
      return date.toLocaleDateString('pt-BR');
    },
    load() {
      if (!this.place?.id_place) {
        this.tasks = [];
        this.$emit('count', 0);
        return;
      }

      http.get(`/places/${this.place.id_place}/tasks`, {
        params: { box: 'inbox' },
      }).then((response) => {
        const userId = this.$store.state.auth.user?.id_user;
        this.tasks = (response.data || []).filter((task) => task.status === 'open'
          || (task.status === 'answered' && (task.reply_all || task.reply_to?.id === userId)));
        this.$emit('count', this.tasks.length);
      }).catch(() => {
        this.tasks = [];
        this.$emit('count', 0);
      });
    },
  },
};
</script>

<style scoped>
.task-cards {
  --task-brand: #780f5a;
  --task-line: #e4e6ef;
  --task-muted: #626777;
  --task-ink: #181c32;
  --task-soft: #f8f5f7;
  display: flex;
  gap: 0.65rem;
  overflow-x: auto;
  padding: 0 1rem 0.85rem;
}
.task-card {
  flex: 0 0 18rem;
  max-width: calc(100vw - 3rem);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
  margin: 0;
  padding: 1rem;
  text-align: left;
  background: var(--card-bg);
  border: 1px solid var(--card-line);
  border-top: 4px solid var(--card-accent);
  border-radius: 0.85rem;
  color: var(--task-ink);
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s;
}
.task-card--open {
  --card-bg: #fffbf3;
  --card-line: #f5d39b;
  --card-accent: #92400e;
  --card-badge: #fef0cf;
}
.task-card--answered {
  --card-bg: #f3fbf6;
  --card-line: #b8dfca;
  --card-accent: #166534;
  --card-badge: #dcf5e5;
}
.task-card:hover {
  border-color: var(--card-accent);
  box-shadow: 0 4px 12px rgba(24, 28, 50, 0.1);
}
.task-card:focus-visible {
  outline: 2px solid var(--card-accent);
  outline-offset: 2px;
}
.task-card__state {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.4rem 0.55rem;
  margin-bottom: 0.3rem;
  border-radius: 0.5rem;
  background: var(--card-badge);
  color: var(--card-accent);
  font-size: 0.75rem;
  font-weight: 700;
}
.task-card__state i { color: inherit; font-size: 1rem; }
.task-card__patient { font-size: 0.85rem; color: var(--task-ink); }
.task-card strong {
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.3;
}
.task-card__type {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--task-brand);
}
.task-card__meta {
  font-size: 0.8rem;
  color: var(--task-muted);
}
</style>
